import { QBankStructureLevelCategory } from '@exam-management/graphql';

export function getUnitByQBSLevelCategory(category?: QBankStructureLevelCategory) {
  switch (category) {
    case QBankStructureLevelCategory.Part:
      return 'หมวด';
    case QBankStructureLevelCategory.Subject:
      return 'วิชา';
    case QBankStructureLevelCategory.Chapter:
      return 'บท';
    default:
      return '';
  }
}

export function getDefaultNameByQBSLevelCategory(category: QBankStructureLevelCategory) {
  return `${getUnitByQBSLevelCategory(category)}: ไม่ระบุ`;
}
